import React, {useEffect} from "react";
import styled from "styled-components";
import {Category} from "../../reducers/project";
import {useDispatch, useSelector} from "react-redux";
import {
  getActiveCategory,
  getAttributesByCategory,
  getSelectedAttributesMapped,
} from "../../reducers/project/selectors";
import setActiveCategory from "../../actions/project/setActiveCategory";
import {isEqual} from "lodash/fp";
import {useDesktop} from "../Responsive";
import {ProjectActions} from "../../reducers/project/actionsNames";

const Text = styled.label<IActiveComponent & IDisableComponent>`
  opacity: ${({ active, disabled }) => (disabled ? 0.4 : active ? 1 : 0.6)};
  color: #080808;
  font-size: 14px;
  font-weight: 600;
`;

const MenuItemWrapper = styled.div<
  IActiveComponent & IDisableComponent & { desktop: boolean }
  >`
  flex-grow: 1;
  display: flex;
  height: ${({ desktop }) => (desktop ? "unset" : "45px")};
  justify-content: center;
  align-items: center;
  font-size: 20px;
  border-bottom: 3px solid
    ${({ active }) => (active ? "#c41230" : "rgba(0, 0, 0, 0)")};
  cursor: ${({ disabled }) => (disabled ? "unset" : "pointer")};
  &:hover {
    border-bottom-color: ${({ active }) =>
  active ? "#c41230" : "rgba(196,18,48,0.6)"};
  }
`;

function MenuItem({ children, category }: IMenuItem) {
  const active = useSelector(getActiveCategory);
  const attr = useSelector(getAttributesByCategory(category));

  const attrColor = useSelector(getSelectedAttributesMapped);

  const anyColor = attrColor.filter(Boolean).some(a => a.category === Category.Color)

  const dispatch = useDispatch();

  const desktop = useDesktop();

  useEffect(() => {
    if(isEqual(active, category) && (category[0] === Category.Glass && !anyColor)){
      dispatch({type: ProjectActions.NextMenu})
    }
  }, [category, active, anyColor])

  const onClick = () => {
    if (attr.length !== 0) {
      dispatch(setActiveCategory(category));
    }
  };

  return (
    <MenuItemWrapper
      desktop={desktop}
      onClick={onClick}
      disabled={attr.length === 0 || (category[0] === Category.Glass && !anyColor)}
      active={isEqual(active, category)}
    >
      <Text disabled={attr.length === 0 || (category[0] === Category.Glass && !anyColor)} active={isEqual(active, category)}>
        {children}
      </Text>
    </MenuItemWrapper>
  );
}

export interface IMenuItem {
  children: React.ReactChild;
  category: Category[];
}

export interface IActiveComponent {
  active?: boolean;
}

export interface IDisableComponent {
  disabled?: boolean;
}

export default MenuItem;
